// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/bg-pattern-light.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table > :not(caption) > * > * {
    padding: 0.6rem 0.95rem !important;
}

body[data-leftbar-theme='dark'] .side-nav .menuitem-active > a {
    color: orange !important;
}

body {
    overflow-x: hidden;
    overflow-y: hidden;
    font-family: 'Roboto', sans-serif;
    scroll-behavior: smooth;
}

.Active_data {
    background: black;
    color: #ecac37e3 !important;
    font-weight: 700;
}

.InActive_data {
    background: #c9c8c8;
    color: white;
}

.cp {
    cursor: pointer;
}

.topbarinfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px !important;
}

.lefbar_info {
    display: flex;
    align-items: center;
}

button.button-menu-mobile.open-left {
    order: 1;
}

ul.list-unstyled.topbar-menu.float-end.mb-0.topbarr {
    order: 3;
}

.menuinfo {
    order: 2;
}

.menuinfo ul li {
    list-style: none;
}

.menuinfo ul {
    padding-left: 0px;
    margin-bottom: 0px;
    display: flex;
    justify-content: space-between;
}

/* .menuinfo ul li {
    padding-right: 15px;
} */

.menuinfo li:last-child {
    padding-right: 0px;
}

.menuinfo ul li a {
    color: #323b47 !important;
    font-size: 16px;
    font-weight: 600;
    padding: 9px 20px;
}

.menuinfo ul li a:hover {
    background-color: #37216c;
    color: orange !important;
}

.project_detail {
    padding: 20px 0px 10px 10px;
    border-bottom: 1px solid #adb1b4;
    margin-bottom: 14px;
}

.taskinfo ul {
    padding-left: 0px;
    list-style: none;
    display: flex;
    margin-bottom: 0px;
    padding-top: 6px;
}

.taskinfo ul li {
    padding-right: 14px;
}

.taskinfo ul li a {
    color: #323b47 !important;
    font-size: 14px;
    font-weight: 600;
}

.taskinfo {
    margin-bottom: 10px;
}

.add_task {
    text-align: right;
}

.rightBar {
    padding: 8px 0px 0px 0px 0px;
    position: fixed;
    overflow-y: hidden;
    display: none;
    top: 0;
    bottom: 0;
    right: -216px;
    height: vh;
    width: 500px;
    transition: opacity 0.3s linear, right 0.3s ease-out;
}

.rightBar.show {
    right: 0px;
    display: block;
    z-index: 1002;
    transition: opacity 0.3s linear, right 0.3s ease-out;
}

.rightBar.show {
    z-index: 1002;
}

.modal-header button {
    /* box-shadow: 0px 2px 6px 0px rgba(57, 175, 209, 0.5); */
    color: #fff;
    background-color: black;
    border-color: black;
    border: 0px;
}

.modal-header {
    display: flex !important;

    border: 100% !important;

    /* border-radius: 100%; */
}

.modal-header button {
    position: absolute;
    right: 10px;
}

.modal-body {
    text-align: left;
}

.modal-body .model-content-detail {
    height: calc(100vh - 6.5rem) !important;
    overflow-y: auto !important;
    padding-bottom: 10px;
}

.priority_status {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.priority {
    display: flex;
    align-items: center;
}

.priority label {
    margin-right: 7px;
}

.menuinfo ul {
    align-items: center;
    display: flex;
}

.project_names select {
    border-left: 0px;
    /* border-bottom: 2px solid gray; */
    font-weight: 600;
    border-right: 0px;
    border-top: 0px;
    color: #323b47 !important;
    border-bottom: none;
    max-width: 123px;
}

option {
    border: none !important;
    /* padding-left:10px; */
}

.action_icon {
    display: flex;
    width: 100%;
    justify-content: flex-end;
}

.action_icon button {
    background: transparent;
    border: 0px;
    padding: 0px;
}

.action_icon button:first-child {
    margin-right: 8px;
}

.dropdown-menu li {
    position: relative;
}

.dropdown-menu .dropdown-submenu {
    display: none;
    position: absolute;
    left: 100%;
    top: -7px;
    margin-top: 4px;
}

.dropdown-menu .dropdown-submenu-left {
    right: 100%;
    left: auto;
}

.dropdown-menu > li > .dropdown-submenu {
    display: block;
}

.dropdown-hover:hover > .dropdown-menu {
    display: inline-block;
}

.dropdown-hover > .dropdown-toggle:active {
    /*Without this, clicking will make it sticky*/
    pointer-events: none;
    color: white;
    background-color: #39afd1;
}

/* summary  */
.all_bg {
    background-color: rgb(218, 235, 255);
}

.bg_clr {
    background-color: rgb(238, 236, 236);
}

.w-size {
    font-size: 20px;
}

.border_clr {
    border: 1px solid rgb(209, 208, 208);
}

.chart_div {
    display: flex;

    height: 36vh;
    margin: 0;
}

.donut-chart {
    display: flex;

    align-items: center;
    max-width: 600px;
}

.donut-chart2 {
    display: flex;
    padding-left: 19%;

    align-items: center;
    max-width: 600px;
}

.chart {
    position: relative;
    width: 245px;
    height: 245px;
    border-radius: 50%;
    background-color: #59d3ec;
    text-align: center;
    margin: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.slice {
    position: absolute;
    width: 50%;
    height: 100%;
    clip-path: polygon(100% 50%, 100% 100%, 0 100%, 0 50%);
    transform-origin: 100%;
    background-color: var(--color);
    transform: rotate(var(--angle));
}

.h1-clr {
    color: #59d3ec;
}

.percentage-label {
    position: absolute;
    width: 100%;
    height: 100%;
    /* font-size: 40px; */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.legend {
    list-style: none;
    padding: 0;
}

.legend li {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.color {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 5px;
}

.day_date {
    font-size: 12px;
}

.scrollable-content {
    height: 300px;
    /* Set the desired height for the scrollable area */
    overflow: auto;
}

/* CSS for the custom scrollbar */
.scrollable-content::-webkit-scrollbar {
    width: 10px;
    /* Width of the scrollbar */
}

.scrollable-content::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.scrollable-content::-webkit-scrollbar-thumb {
    background: #4141413c;
    border-radius: 10px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
    background: #888;
}

.i_f {
    font-size: 38px;
    font-weight: 400;
}

.icon_s {
    font-size: 22px;
}

/* .project_opt{
        padding: 10px;
    } */
.drop_s {
    padding: 0.375rem 1.5rem;
}

.border_zero {
    border: 0px !important;
}

.chip {
    background: #39afd1 !important;
    border-radius: 30px !important;
}

.highlightOption {
    background-color: white !important;
    color: black !important;
}

.option:hover {
    background: #39afd1 !important;
    color: white;
}

.closeIcon {
    margin-left: 14px !important;
}

.searchWrapper {
    height: 37px !important;
    overflow: overlay !important;
}

.checkbox {
    /* margin-right: 10px; */
    display: none !important;
}

.hover_bg:hover {
    background-color: #39afd1 !important;
}

.img_div img {
    width: 100px;
    height: 100px;
}

.all_logo_img {
    height: auto !important;
    width: 250px !important;
}

.cross_div {
    background: black;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(6px, -4px);
    color: white;
    border-radius: 10px;
    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    cursor: pointer;
}

.web_button {
    background-color: black !important;
    color: white !important;
    box-shadow: none !important;
    border: none !important;
    font-size: 13px !important;
    height: 35px !important;
}

.month-nav:hover {
    background-color: black !important;
    color: white !important;
    box-shadow: none !important;
    border: none !important;
    transition-duration: 0.3s !important;
}
.month-nav {
    border: 1px solid black !important;
    color: black !important;
    box-shadow: none !important;
    background-color: transparent !important;
}

.add_color_gray {
    background-color: #b5b4b4;
    color: white;
}

.add_color_gray:hover {
    background-color: #37216c;
    color: white;
}

.leftside-menu {
    background-color: black !important;
}

span.logo-lg {
    background: #313a46 !important;
    /* border-bottom: 1px solid #b5852d !important; */
}

.mdi.mdi-eye {
    color: black;
}

.form-switch .form-check-input:checked[type='checkbox']:after {
    background-color: #fff !important;
    width: 1rem !important;
    height: 1rem !important;
    /* background-color: #3b71ca; */
    margin-top: -1px !important;
    margin-left: 0.8rem !important;
}

.form-check-input[type='checkbox']:checked {
    /* background-image: none; */
    background-color: #727cf5 !important;
}

table.table-striped tbody tr:nth-of-type(odd) > * {
    --ct-table-accent-bg: #c9c8c8 !important;
}

.name_div {
    background: #e2dadb !important;
    color: #37216c;
    border-radius: 10px;
}

.add_round {
    border-radius: 20px;
}

.css-1com30x {
    height: 73vh !important;
    overflow-y: auto !important;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}

.add_height_task {
    height: 80vh !important;
    overflow-y: auto !important;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}

.add_position {
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    transform: translate(-12px, 40px);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* z-index: 99999; */
}

.page-title {
    /* background: #37216c !important; */
    font-size: 11px !important;
    margin-top: 13px !important;
}

.css-1xb58ew {
    margin: 0px !important;
}

.css-1com30x {
    min-width: 347px !important;
}

.small-width {
    width: 10px !important;
    /* background-color: red !important; */
}

.task-title {
    /* background-color: red; */
    padding: 7px 30px;
    color: rgb(88, 88, 226);
    font-size: 13px !important;
    /* font-family: ' sans-serif'; */
    font-weight: bold !important;
}

/* .css-1xb58ew {
    overflow: hidden !important;
} */
.form-switch .form-check-input {
    width: 2em !important;
    margin-left: -2.5em !important;
}

.form-switch .form-check-input:after {
    width: 1rem !important;
    height: 1rem !important;
    margin-top: -1px !important;
}

.side-nav-item {
    color: white !important;
}

.side-nav-link {
    color: white !important;
}

.bg_clr {
    height: 75px;
    width: 75px;
}

.add_position_modal_edit {
    transform: translate(-611px, 12.5rem);
    border-radius: 6px;
}

tr {
    text-align: center;
}

.header-title.heading_data {
    font-size: 20px !important;
    font-weight: 700 !important;
}

.projects_info {
    display: flex;
    flex-wrap: wrap;
}

.projects_info p {
    text-align: center;
    flex: 0 0 14%;
}

.modal_titles {
    font-size: 1.25rem;
    font-weight: 600;
}

.add_width_input {
    width: 100%;
    padding: 0.5rem;
    border-radius: 0.25rem;
}

/* In your CSS file */
.custom-close-btn {
    background-color: black;
    font-weight: 800 !important;
}

@media (min-width: 1300px) and (max-width: 1700px) {
    .add_position_modal_edit {
        transform: translate(-422px, 11.5rem) !important;
    }
}

/* .modal-backdrop.fade {
    opacity: 0 !important;
} */
.react-datepicker-wrapper {
    /* border: 1px solid gray; */
    width: 100%;
}

input.add_width_input {
    border: 1px solid #d8cccc;
    width: 100%;
    padding: 6px;
    border-radius: 4px;
}

.modal-content {
    height: auto !important;
}

.add_padding_box {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
}

.add_padding_box {
    background: #c9c8c8 !important;
    /* text: white !important; */
}

.del_edit {
    color: white;
}

.list-table-filter:focus {
    outline: none !important;
}

.blur-background {
    -webkit-backdrop-filter: blur(2px);
            backdrop-filter: blur(2px);
    background-color: #6e757d47;
    /* Adjust the blur intensity as needed */
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.active-button-tdp {
    background-color: lightblue !important;
    color: #6169d0 !important;
}

.inactive-button-tdp {
    background-color: #c9c8c8 !important;
    color: white !important;
}

.modal_titles,
.page_headings {
    font-weight: 900 !important;
    color: black !important;
    font-size: 18px !important;
}

.task-page-columns {
    height: 70vh !important;
    overflow-y: auto !important;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}

.task-page-columns-dash {
    height: 80vh !important;
    overflow-y: auto !important;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}

.dropdown-style {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22) !important;
}

.transparent-bg {
    background-color: transparent !important;
}

.cursor_p:hover {
    cursor: pointer !important;
}

.password-eye:before {
    font-feature-settings: normal;
    content: '󰛐';
    font-family: Material Design Icons;
    font-size: 16px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    line-height: 1.2;
    vertical-align: middle;
}

/* Fix for validation message spacing */
.invalid-feedback {
    margin-top: 0 !important;
    padding-top: 0 !important;
    position: relative !important;
    top: -5px !important;
}

.account-pages {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    /* Adjust path as needed */
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    align-items: center;
    display: flex;
    min-height: 100vh;
}

.animate-pulse {
    animation: pulse 1.5s ease-in-out infinite;
}

/* @keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }

.form-check-input:focus:before {
    box-shadow: none !important;
}

.css-1xc3v61-indicatorContainer {
    padding: 0% !important
} */

.projectSelector .css-b62m3t-container .css-eq1z8s-control {
    height: 100% !important;
}

.taskCardIcons {
    font-size: 1rem !important;
}

.taskCardIcons:hover {
    color: #727cf5 !important;
}

/* Reduce font size for all input fields */
input[type='text'],
input[type='email'],
input[type='password'],
input[type='number'],
input[type='tel'],
input[type='url'],
input[type='search'],
input[type='date'],
input[type='time'],
input[type='datetime-local'],
input[type='month'],
input[type='week'],
select,
textarea,
.form-control,
.form-select {
    font-size: 12px !important;
}

/* React Select components */
.react-select-container .react-select__control,
.react-select-container .react-select__single-value,
.react-select-container .react-select__input,
.react-select-container .react-select__placeholder,
.react-select-container .react-select__option {
    font-size: 12px !important;
}

.task-preview-modal .modal-dialog .modal-content .modal-body {
    height: 80vh;
}

.list-group-item {
    padding: 1rem;
}

.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* .table-container {
    overflow: visible !important;
} */

.dropdown-menu {
    max-height: 300px;
    overflow-y: auto;
    z-index: 9999 !important;
}

/* .table-container,
.table,
.card-body,
.react-bootstrap-table,
.parent-of-dropdown {
    overflow: visible !important;
    position: relative !important;
} */

/* .chat-users {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.users-list {
    height: calc(100% - 60px);
    overflow-y: auto;
}

.chat-messages {
    height: calc(100% - 120px);
    overflow-y: auto;
}

.user-item {
    transition: background-color 0.2s ease;
}

.user-item:hover {
    background-color: rgba(0, 0, 0, 0.05) !important;
}

.message-content {
    max-width: 70%;
    word-wrap: break-word;
}

.user-status {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid white;
} */

.frozen-table-container .table thead th {
    position: sticky;
    top: 0;
    background-color: #212529;
    color: white;
    z-index: 4;
}

/* Improved scroll handling */
.smooth-scroll {
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

.scroll-container {
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

.scroll-container::-webkit-scrollbar {
    width: 6px;
}

.scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.scroll-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
    -webkit-transition: background 0.2s ease;
    transition: background 0.2s ease;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Fix for scroll restoration */
.scroll-restore {
    scroll-behavior: auto !important;
}

/* Prevent scroll jumping */
.no-scroll-jump {
    contain: layout style paint;
}

.form {
    height: 30px !important;
}

.formSelect {
    height: 30px !important;
    padding-top: 5px !important;
}

.offcanvas-backdrop.show {
    opacity: 0.03 !important;
}

.invisible-scroll-y {
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer/Edge */
}

.invisible-scroll-y::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

/* Green Notification Dot for Admin Sidebar */
.admin-sidebar-green-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #10b981;
    border-radius: 50%;
    margin-top: 8px;
    margin-right: 4px;
    float: right;
    flex-shrink: 0;
    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.25), 0 0 8px #10b981;
    animation: sidebarGreenPulse 2s infinite ease-in-out;
}

@keyframes sidebarGreenPulse {
    0%, 100% {
        transform: scale(1);
        box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.25), 0 0 6px #10b981;
    }
    50% {
        transform: scale(1.25);
        box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.45), 0 0 10px #10b981;
    }
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,SAAS;IACT,aAAa;IACb,UAAU;IACV,YAAY;IAIZ,oDAAoD;AACxD;;AAEA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IAIb,oDAAoD;AACxD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yDAAyD;IACzD,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;;IAExB,uBAAuB;;IAEvB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;IAC7C,oBAAoB;IACpB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;;IAEb,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;;IAEb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;;IAEjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,sDAAsD;IACtD,sBAAsB;IACtB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mDAAmD;IACnD,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;OAEO;AACP;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,oCAAoC;AACxC;AACA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,iDAAiD;AACrD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,+BAA+B;IAC/B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;IAC1B,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;;GAEG;AACH;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;;GAEG;AACH;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kCAA0B;YAA1B,0BAA0B;IAC1B,2BAA2B;IAC3B,wCAAwC;IACxC,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;;IAEI,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,uCAAuC;AACvC;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,yDAA2D;IAC3D,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0CAA0C;AAC1C;;;;;;;;;;;;;;;;IAgBI,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;;;;;IAKI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqCG;;AAEH;IACI,gBAAgB;IAChB,MAAM;IACN,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA,6BAA6B;AAC7B;IACI,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,wCAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,gCAAgC;AACpC;;AAEA,2BAA2B;AAC3B;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,2BAA2B;AACzD;;AAEA;IACI,aAAa,EAAE,0BAA0B;AAC7C;;AAEA,6CAA6C;AAC7C;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,+DAA+D;IAC/D,oDAAoD;AACxD;;AAEA;IACI;QACI,mBAAmB;QACnB,+DAA+D;IACnE;IACA;QACI,sBAAsB;QACtB,gEAAgE;IACpE;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');\n\n.table > :not(caption) > * > * {\n    padding: 0.6rem 0.95rem !important;\n}\n\nbody[data-leftbar-theme='dark'] .side-nav .menuitem-active > a {\n    color: orange !important;\n}\n\nbody {\n    overflow-x: hidden;\n    overflow-y: hidden;\n    font-family: 'Roboto', sans-serif;\n    scroll-behavior: smooth;\n}\n\n.Active_data {\n    background: black;\n    color: #ecac37e3 !important;\n    font-weight: 700;\n}\n\n.InActive_data {\n    background: #c9c8c8;\n    color: white;\n}\n\n.cp {\n    cursor: pointer;\n}\n\n.topbarinfo {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 45px !important;\n}\n\n.lefbar_info {\n    display: flex;\n    align-items: center;\n}\n\nbutton.button-menu-mobile.open-left {\n    order: 1;\n}\n\nul.list-unstyled.topbar-menu.float-end.mb-0.topbarr {\n    order: 3;\n}\n\n.menuinfo {\n    order: 2;\n}\n\n.menuinfo ul li {\n    list-style: none;\n}\n\n.menuinfo ul {\n    padding-left: 0px;\n    margin-bottom: 0px;\n    display: flex;\n    justify-content: space-between;\n}\n\n/* .menuinfo ul li {\n    padding-right: 15px;\n} */\n\n.menuinfo li:last-child {\n    padding-right: 0px;\n}\n\n.menuinfo ul li a {\n    color: #323b47 !important;\n    font-size: 16px;\n    font-weight: 600;\n    padding: 9px 20px;\n}\n\n.menuinfo ul li a:hover {\n    background-color: #37216c;\n    color: orange !important;\n}\n\n.project_detail {\n    padding: 20px 0px 10px 10px;\n    border-bottom: 1px solid #adb1b4;\n    margin-bottom: 14px;\n}\n\n.taskinfo ul {\n    padding-left: 0px;\n    list-style: none;\n    display: flex;\n    margin-bottom: 0px;\n    padding-top: 6px;\n}\n\n.taskinfo ul li {\n    padding-right: 14px;\n}\n\n.taskinfo ul li a {\n    color: #323b47 !important;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.taskinfo {\n    margin-bottom: 10px;\n}\n\n.add_task {\n    text-align: right;\n}\n\n.rightBar {\n    padding: 8px 0px 0px 0px 0px;\n    position: fixed;\n    overflow-y: hidden;\n    display: none;\n    top: 0;\n    bottom: 0;\n    right: -216px;\n    height: vh;\n    width: 500px;\n    -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;\n    -moz-transition: opacity 0.3s linear, right 0.3s ease-out;\n    -o-transition: opacity 0.3s linear, right 0.3s ease-out;\n    transition: opacity 0.3s linear, right 0.3s ease-out;\n}\n\n.rightBar.show {\n    right: 0px;\n    display: block;\n    z-index: 1002;\n    -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;\n    -moz-transition: opacity 0.3s linear, right 0.3s ease-out;\n    -o-transition: opacity 0.3s linear, right 0.3s ease-out;\n    transition: opacity 0.3s linear, right 0.3s ease-out;\n}\n\n.rightBar.show {\n    z-index: 1002;\n}\n\n.modal-header button {\n    /* box-shadow: 0px 2px 6px 0px rgba(57, 175, 209, 0.5); */\n    color: #fff;\n    background-color: black;\n    border-color: black;\n    border: 0px;\n}\n\n.modal-header {\n    display: flex !important;\n\n    border: 100% !important;\n\n    /* border-radius: 100%; */\n}\n\n.modal-header button {\n    position: absolute;\n    right: 10px;\n}\n\n.modal-body {\n    text-align: left;\n}\n\n.modal-body .model-content-detail {\n    height: calc(100vh - 6.5rem) !important;\n    overflow-y: auto !important;\n    padding-bottom: 10px;\n}\n\n.priority_status {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.priority {\n    display: flex;\n    align-items: center;\n}\n\n.priority label {\n    margin-right: 7px;\n}\n\n.menuinfo ul {\n    align-items: center;\n    display: flex;\n}\n\n.project_names select {\n    border-left: 0px;\n    /* border-bottom: 2px solid gray; */\n    font-weight: 600;\n    border-right: 0px;\n    border-top: 0px;\n    color: #323b47 !important;\n    border-bottom: none;\n    max-width: 123px;\n}\n\noption {\n    border: none !important;\n    /* padding-left:10px; */\n}\n\n.action_icon {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n}\n\n.action_icon button {\n    background: transparent;\n    border: 0px;\n    padding: 0px;\n}\n\n.action_icon button:first-child {\n    margin-right: 8px;\n}\n\n.dropdown-menu li {\n    position: relative;\n}\n\n.dropdown-menu .dropdown-submenu {\n    display: none;\n    position: absolute;\n    left: 100%;\n    top: -7px;\n    margin-top: 4px;\n}\n\n.dropdown-menu .dropdown-submenu-left {\n    right: 100%;\n    left: auto;\n}\n\n.dropdown-menu > li > .dropdown-submenu {\n    display: block;\n}\n\n.dropdown-hover:hover > .dropdown-menu {\n    display: inline-block;\n}\n\n.dropdown-hover > .dropdown-toggle:active {\n    /*Without this, clicking will make it sticky*/\n    pointer-events: none;\n    color: white;\n    background-color: #39afd1;\n}\n\n/* summary  */\n.all_bg {\n    background-color: rgb(218, 235, 255);\n}\n\n.bg_clr {\n    background-color: rgb(238, 236, 236);\n}\n\n.w-size {\n    font-size: 20px;\n}\n\n.border_clr {\n    border: 1px solid rgb(209, 208, 208);\n}\n\n.chart_div {\n    display: flex;\n\n    height: 36vh;\n    margin: 0;\n}\n\n.donut-chart {\n    display: flex;\n\n    align-items: center;\n    max-width: 600px;\n}\n\n.donut-chart2 {\n    display: flex;\n    padding-left: 19%;\n\n    align-items: center;\n    max-width: 600px;\n}\n\n.chart {\n    position: relative;\n    width: 245px;\n    height: 245px;\n    border-radius: 50%;\n    background-color: #59d3ec;\n    text-align: center;\n    margin: 20px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.slice {\n    position: absolute;\n    width: 50%;\n    height: 100%;\n    clip-path: polygon(100% 50%, 100% 100%, 0 100%, 0 50%);\n    transform-origin: 100%;\n    background-color: var(--color);\n    transform: rotate(var(--angle));\n}\n\n.h1-clr {\n    color: #59d3ec;\n}\n\n.percentage-label {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    /* font-size: 40px; */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n\n.legend {\n    list-style: none;\n    padding: 0;\n}\n\n.legend li {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.color {\n    width: 20px;\n    height: 20px;\n    margin-right: 10px;\n    border-radius: 5px;\n}\n\n.day_date {\n    font-size: 12px;\n}\n\n.scrollable-content {\n    height: 300px;\n    /* Set the desired height for the scrollable area */\n    overflow: auto;\n}\n\n/* CSS for the custom scrollbar */\n.scrollable-content::-webkit-scrollbar {\n    width: 10px;\n    /* Width of the scrollbar */\n}\n\n.scrollable-content::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb {\n    background: #4141413c;\n    border-radius: 10px;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb:hover {\n    background: #888;\n}\n\n.i_f {\n    font-size: 38px;\n    font-weight: 400;\n}\n\n.icon_s {\n    font-size: 22px;\n}\n\n/* .project_opt{\n        padding: 10px;\n    } */\n.drop_s {\n    padding: 0.375rem 1.5rem;\n}\n\n.border_zero {\n    border: 0px !important;\n}\n\n.chip {\n    background: #39afd1 !important;\n    border-radius: 30px !important;\n}\n\n.highlightOption {\n    background-color: white !important;\n    color: black !important;\n}\n\n.option:hover {\n    background: #39afd1 !important;\n    color: white;\n}\n\n.closeIcon {\n    margin-left: 14px !important;\n}\n\n.searchWrapper {\n    height: 37px !important;\n    overflow: overlay !important;\n}\n\n.checkbox {\n    /* margin-right: 10px; */\n    display: none !important;\n}\n\n.hover_bg:hover {\n    background-color: #39afd1 !important;\n}\n\n.img_div img {\n    width: 100px;\n    height: 100px;\n}\n\n.all_logo_img {\n    height: auto !important;\n    width: 250px !important;\n}\n\n.cross_div {\n    background: black;\n    position: absolute;\n    top: 0;\n    right: 0;\n    transform: translate(6px, -4px);\n    color: white;\n    border-radius: 10px;\n    width: 1rem;\n    height: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    cursor: pointer;\n}\n\n.web_button {\n    background-color: black !important;\n    color: white !important;\n    box-shadow: none !important;\n    border: none !important;\n    font-size: 13px !important;\n    height: 35px !important;\n}\n\n.month-nav:hover {\n    background-color: black !important;\n    color: white !important;\n    box-shadow: none !important;\n    border: none !important;\n    transition-duration: 0.3s !important;\n}\n.month-nav {\n    border: 1px solid black !important;\n    color: black !important;\n    box-shadow: none !important;\n    background-color: transparent !important;\n}\n\n.add_color_gray {\n    background-color: #b5b4b4;\n    color: white;\n}\n\n.add_color_gray:hover {\n    background-color: #37216c;\n    color: white;\n}\n\n.leftside-menu {\n    background-color: black !important;\n}\n\nspan.logo-lg {\n    background: #313a46 !important;\n    /* border-bottom: 1px solid #b5852d !important; */\n}\n\n.mdi.mdi-eye {\n    color: black;\n}\n\n.form-switch .form-check-input:checked[type='checkbox']:after {\n    background-color: #fff !important;\n    width: 1rem !important;\n    height: 1rem !important;\n    /* background-color: #3b71ca; */\n    margin-top: -1px !important;\n    margin-left: 0.8rem !important;\n}\n\n.form-check-input[type='checkbox']:checked {\n    /* background-image: none; */\n    background-color: #727cf5 !important;\n}\n\ntable.table-striped tbody tr:nth-of-type(odd) > * {\n    --ct-table-accent-bg: #c9c8c8 !important;\n}\n\n.name_div {\n    background: #e2dadb !important;\n    color: #37216c;\n    border-radius: 10px;\n}\n\n.add_round {\n    border-radius: 20px;\n}\n\n.css-1com30x {\n    height: 73vh !important;\n    overflow-y: auto !important;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n}\n\n.add_height_task {\n    height: 80vh !important;\n    overflow-y: auto !important;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n}\n\n.add_position {\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    transform: translate(-12px, 40px);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    /* z-index: 99999; */\n}\n\n.page-title {\n    /* background: #37216c !important; */\n    font-size: 11px !important;\n    margin-top: 13px !important;\n}\n\n.css-1xb58ew {\n    margin: 0px !important;\n}\n\n.css-1com30x {\n    min-width: 347px !important;\n}\n\n.small-width {\n    width: 10px !important;\n    /* background-color: red !important; */\n}\n\n.task-title {\n    /* background-color: red; */\n    padding: 7px 30px;\n    color: rgb(88, 88, 226);\n    font-size: 13px !important;\n    /* font-family: ' sans-serif'; */\n    font-weight: bold !important;\n}\n\n/* .css-1xb58ew {\n    overflow: hidden !important;\n} */\n.form-switch .form-check-input {\n    width: 2em !important;\n    margin-left: -2.5em !important;\n}\n\n.form-switch .form-check-input:after {\n    width: 1rem !important;\n    height: 1rem !important;\n    margin-top: -1px !important;\n}\n\n.side-nav-item {\n    color: white !important;\n}\n\n.side-nav-link {\n    color: white !important;\n}\n\n.bg_clr {\n    height: 75px;\n    width: 75px;\n}\n\n.add_position_modal_edit {\n    transform: translate(-611px, 12.5rem);\n    border-radius: 6px;\n}\n\ntr {\n    text-align: center;\n}\n\n.header-title.heading_data {\n    font-size: 20px !important;\n    font-weight: 700 !important;\n}\n\n.projects_info {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.projects_info p {\n    text-align: center;\n    flex: 0 0 14%;\n}\n\n.modal_titles {\n    font-size: 1.25rem;\n    font-weight: 600;\n}\n\n.add_width_input {\n    width: 100%;\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n}\n\n/* In your CSS file */\n.custom-close-btn {\n    background-color: black;\n    font-weight: 800 !important;\n}\n\n@media (min-width: 1300px) and (max-width: 1700px) {\n    .add_position_modal_edit {\n        transform: translate(-422px, 11.5rem) !important;\n    }\n}\n\n/* .modal-backdrop.fade {\n    opacity: 0 !important;\n} */\n.react-datepicker-wrapper {\n    /* border: 1px solid gray; */\n    width: 100%;\n}\n\ninput.add_width_input {\n    border: 1px solid #d8cccc;\n    width: 100%;\n    padding: 6px;\n    border-radius: 4px;\n}\n\n.modal-content {\n    height: auto !important;\n}\n\n.add_padding_box {\n    padding-top: 3px !important;\n    padding-bottom: 3px !important;\n}\n\n.add_padding_box {\n    background: #c9c8c8 !important;\n    /* text: white !important; */\n}\n\n.del_edit {\n    color: white;\n}\n\n.list-table-filter:focus {\n    outline: none !important;\n}\n\n.blur-background {\n    backdrop-filter: blur(2px);\n    background-color: #6e757d47;\n    /* Adjust the blur intensity as needed */\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.active-button-tdp {\n    background-color: lightblue !important;\n    color: #6169d0 !important;\n}\n\n.inactive-button-tdp {\n    background-color: #c9c8c8 !important;\n    color: white !important;\n}\n\n.modal_titles,\n.page_headings {\n    font-weight: 900 !important;\n    color: black !important;\n    font-size: 18px !important;\n}\n\n.task-page-columns {\n    height: 70vh !important;\n    overflow-y: auto !important;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n}\n\n.task-page-columns-dash {\n    height: 80vh !important;\n    overflow-y: auto !important;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n}\n\n.dropdown-style {\n    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22) !important;\n}\n\n.transparent-bg {\n    background-color: transparent !important;\n}\n\n.cursor_p:hover {\n    cursor: pointer !important;\n}\n\n.password-eye:before {\n    font-feature-settings: normal;\n    content: '󰛐';\n    font-family: Material Design Icons;\n    font-size: 16px;\n    font-style: normal;\n    font-variant: normal;\n    font-weight: 400;\n    line-height: 1.2;\n    vertical-align: middle;\n}\n\n/* Fix for validation message spacing */\n.invalid-feedback {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    position: relative !important;\n    top: -5px !important;\n}\n\n.account-pages {\n    background-image: url('assets/images/bg-pattern-light.svg');\n    /* Adjust path as needed */\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 100%;\n    align-items: center;\n    display: flex;\n    min-height: 100vh;\n}\n\n.animate-pulse {\n    animation: pulse 1.5s ease-in-out infinite;\n}\n\n/* @keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n\n.form-check-input:focus:before {\n    box-shadow: none !important;\n}\n\n.css-1xc3v61-indicatorContainer {\n    padding: 0% !important\n} */\n\n.projectSelector .css-b62m3t-container .css-eq1z8s-control {\n    height: 100% !important;\n}\n\n.taskCardIcons {\n    font-size: 1rem !important;\n}\n\n.taskCardIcons:hover {\n    color: #727cf5 !important;\n}\n\n/* Reduce font size for all input fields */\ninput[type='text'],\ninput[type='email'],\ninput[type='password'],\ninput[type='number'],\ninput[type='tel'],\ninput[type='url'],\ninput[type='search'],\ninput[type='date'],\ninput[type='time'],\ninput[type='datetime-local'],\ninput[type='month'],\ninput[type='week'],\nselect,\ntextarea,\n.form-control,\n.form-select {\n    font-size: 12px !important;\n}\n\n/* React Select components */\n.react-select-container .react-select__control,\n.react-select-container .react-select__single-value,\n.react-select-container .react-select__input,\n.react-select-container .react-select__placeholder,\n.react-select-container .react-select__option {\n    font-size: 12px !important;\n}\n\n.task-preview-modal .modal-dialog .modal-content .modal-body {\n    height: 80vh;\n}\n\n.list-group-item {\n    padding: 1rem;\n}\n\n.text-truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* .table-container {\n    overflow: visible !important;\n} */\n\n.dropdown-menu {\n    max-height: 300px;\n    overflow-y: auto;\n    z-index: 9999 !important;\n}\n\n/* .table-container,\n.table,\n.card-body,\n.react-bootstrap-table,\n.parent-of-dropdown {\n    overflow: visible !important;\n    position: relative !important;\n} */\n\n/* .chat-users {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.users-list {\n    height: calc(100% - 60px);\n    overflow-y: auto;\n}\n\n.chat-messages {\n    height: calc(100% - 120px);\n    overflow-y: auto;\n}\n\n.user-item {\n    transition: background-color 0.2s ease;\n}\n\n.user-item:hover {\n    background-color: rgba(0, 0, 0, 0.05) !important;\n}\n\n.message-content {\n    max-width: 70%;\n    word-wrap: break-word;\n}\n\n.user-status {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    border: 2px solid white;\n} */\n\n.frozen-table-container .table thead th {\n    position: sticky;\n    top: 0;\n    background-color: #212529;\n    color: white;\n    z-index: 4;\n}\n\n/* Improved scroll handling */\n.smooth-scroll {\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n}\n\n.scroll-container {\n    overflow-y: auto;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n}\n\n.scroll-container::-webkit-scrollbar {\n    width: 6px;\n}\n\n.scroll-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n}\n\n.scroll-container::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n    transition: background 0.2s ease;\n}\n\n.scroll-container::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}\n\n/* Fix for scroll restoration */\n.scroll-restore {\n    scroll-behavior: auto !important;\n}\n\n/* Prevent scroll jumping */\n.no-scroll-jump {\n    contain: layout style paint;\n}\n\n.form {\n    height: 30px !important;\n}\n\n.formSelect {\n    height: 30px !important;\n    padding-top: 5px !important;\n}\n\n.offcanvas-backdrop.show {\n    opacity: 0.03 !important;\n}\n\n.invisible-scroll-y {\n    overflow-y: scroll;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* Internet Explorer/Edge */\n}\n\n.invisible-scroll-y::-webkit-scrollbar {\n    display: none; /* Chrome, Safari, Opera */\n}\n\n/* Green Notification Dot for Admin Sidebar */\n.admin-sidebar-green-dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    background-color: #10b981;\n    border-radius: 50%;\n    margin-top: 8px;\n    margin-right: 4px;\n    float: right;\n    flex-shrink: 0;\n    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.25), 0 0 8px #10b981;\n    animation: sidebarGreenPulse 2s infinite ease-in-out;\n}\n\n@keyframes sidebarGreenPulse {\n    0%, 100% {\n        transform: scale(1);\n        box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.25), 0 0 6px #10b981;\n    }\n    50% {\n        transform: scale(1.25);\n        box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.45), 0 0 10px #10b981;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
